import { API } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

/**
 * USER가 대표자 신용조회 문자를 재전송합니다.
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/term-request-controller/resend
 *
 * @param companyId
 * @param termRequestId
 * @param ceoCreditAgreementsId
 * @returns
 */
export default function resendCeoCreditAgreements(companyId: string) {
  return API.post<ResponseBase>(
    `/api/v2/companies/${companyId}/ceo-credit-agreements/resend-for-waiting`,
  );
}
